import { BigNumber } from 'ethers'

/**
 * Computes current Goo Balance from a previous snapshot of
 * @param lastBalance integer, scaled by 1e18
 * @param lastTimestamp integer, seconds since unix epooch
 * @param emissionMultiple integer, ∈ [6, 9]
 * @param targetUnixTimestamp optional. integer, unix timestamp
 */
const calculateGooBalanceFromSnapshot = (
  lastBalance: bigint,
  lastTimestamp: number,
  emissionMultiple: number,
  targetUnixTimestamp: number = Date.now(),
) => {
  const lastBalanceInUnits = lastBalance / BigInt(1e18) // Comes in scaled by 1e18.

  const lastBalanceFloat = Number(lastBalanceInUnits)
  // Divide by 1000 and floor to get a timestamp of just
  // seconds. Divide by 86400 to convert seconds into days.
  const daysElapsed = (Math.floor(targetUnixTimestamp / 1000) - lastTimestamp) / 86400

  const daysElapsedSquared = daysElapsed * daysElapsed // Could use ** 2 as well.

  const currentBalance =
    lastBalanceFloat +
    (emissionMultiple * daysElapsedSquared) / 4 +
    daysElapsed * Math.sqrt(emissionMultiple * lastBalanceFloat)

  return currentBalance
}

const calculateGooProductionRate = (gooInTank: number, multiplier: number) => {
  return Math.sqrt(gooInTank * multiplier)
}

export { calculateGooBalanceFromSnapshot, calculateGooProductionRate }
